<template>
	<div dir="ltr">
		<div class="columns is-align-items-center">
			<div class="column is-5">
				<a @click="createNewRecruiterFee" class="button is-info">Create new recruiter fee</a>
			</div>

			<div class="column flex flex_align_center flex_justify_end" >
				<label class="checkbox">
					<input type="checkbox" v-model="is_fees_applied" :disabled="is_loading" @change="checkboxCheck">
					Fees applied
				</label>
			</div>
		</div>
		<br >
		<div>
			<div v-for="(recruiter_fee, idx) in recruiter_fees" :key="idx" class="flex flex_align_center columns">
				<div class="column">
					<p>{{ recruiter_fee.recruiter_name }} <span>({{ getRecruiterFee(recruiter_fee.fee) || 'לא הוגדר עמלה' }})</span></p>
				</div>
				<div class="column is-2">
					<a @click="editRecruiterFee(recruiter_fee)" class="button is-info is-outlined">Edit Fee</a>
				</div>
				<div class="column is-2">
					<a @click="deleteRecruiterFee(recruiter_fee)" class="button is-danger is-outlined">Delete</a>
				</div>
			</div>
			<div v-if="is_loading" class="loading"></div>
			<p dir="ltr" v-if="!is_loading && recruiter_fees.length == 0">No recruiter fees in this offer.</p>
		</div>
	</div>
</template>
<script>
	// imports
	import { mapMutations, mapActions } from 'vuex'

	// constants
	import { STORE_NAMESPACE, FETCH_ALL } from '@/store/modules/recruiters_fees/types'

	export default {
		name: 'offer-fees-for',
		props: ['payload'],
		data(){
			return {
				data: this.payload.data,
				is_loading: false,
				is_fees_applied: this.payload.data.is_fees_applied,
				recruiter_fees: [],
			}
		},
		created(){
			this.init()
			this[FETCH_ALL]()
		},
		methods: {
			...mapActions(STORE_NAMESPACE, [FETCH_ALL]),
			init(){
				this.is_loading = true
				this.$network_utils.getRecruiterFees({ offer_id: this.payload.data.id }).then(response => {
					this.recruiter_fees = response
					this.is_loading = false
				})
			},
			checkboxCheck(e) {
				this.is_loading = true
				const updated = {...this.data, is_fees_applied: e.target.checked}
				this.$network_utils.updateOffer(updated).then(response => {
					this.data = response
					this.is_loading = false
				})
			},
			createNewRecruiterFee(){
				this.createModal({
					component_name: 'RecruiterFeeForm',
					modal_title: 'Create New Recruiter Fee',
					offer: this.payload.data,
					is_create: true,
					callback: this.init
				})
			},
			editRecruiterFee(recruiter_fee){
				this.createModal({
					component_name: 'RecruiterFeeForm',
					modal_title: recruiter_fee.recruiter_name,
					data: recruiter_fee,
					offer: this.payload.data,
					callback: this.init
				})
			},
			deleteRecruiterFee(delete_data){
				this.createModal({
					designator: 'delete-prompt',
					component_name: 'DeletePrompt',
					modal_title: 'Delete ' + delete_data.recruiter_name,
					item_name: delete_data.recruiter_name,
					method: 'deleteRecruiterFee',
					method_params: { id: delete_data.id },
					refresh: this.init
				})
			},
			getRecruiterFee(fee){
				let payment = this.$offers_helper.getPayment(this.payload.data, false)
				let recruiter_fee_payment = payment * (fee / 100)
				return `${recruiter_fee_payment} ש"ח / ${fee}%`
			},
			...mapMutations('modals', ['createModal'])
		}
	}
</script>